import React from 'react';
import { Icon } from './Icon.js';
export const IconEqualGreaterThan = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 21H19", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M18.4707 9.11719L20.125 10L18.4707 10.8828L4 18.5996V16.332L15.874 10L4 3.66699V1.40039L18.4707 9.11719Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconEqualGreaterThan.js.map